import { render, staticRenderFns } from "./createdSKU.vue?vue&type=template&id=201567b6&scoped=true&"
import script from "./createdSKU.vue?vue&type=script&lang=js&"
export * from "./createdSKU.vue?vue&type=script&lang=js&"
import style0 from "./createdSKU.vue?vue&type=style&index=0&id=201567b6&lang=scss&scoped=true&"
import style1 from "./createdSKU.vue?vue&type=style&index=1&id=201567b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201567b6",
  null
  
)

export default component.exports